export const ECronJobType = {
  "0": "UNKNOWN",
  "1": "HENGEFELD_BENCHMARK",
  "2": "AUTOCOMPLETE_HOTEL_IMPORT",
  "3": "AUTOCOMPLETE_TRANSFER_IMPORT",
  "4": "HOTEL_CONTENT_IMPORT",
  "-1": "ALL"
};